
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/[restaurantSlug]/category",
      function () {
        return require("private-next-pages/menu/[restaurantSlug]/category/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/[restaurantSlug]/category"])
      });
    }
  